// Generated by `bazel run i18n`. Do not edit by hand.
import errors_f2d716f9 from "./en/src--draft-return--errors.json";
import returns_881acbbd from "./en/src--returns.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  errors_f2d716f9,
  returns_881acbbd,
  src_c1a2d0b5,
);
